import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Menu } from 'lucide-react';
import Sidebar from './Sidebar';
import NewOrdersPopup from './NewOrdersPopup';
import { useAuth } from '../context/AuthContext';

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const { can } = useAuth();

  // Close the mobile/tablet drawer whenever the route changes (covers back/
  // forward navigation and programmatic redirects, in addition to the
  // Sidebar's own onClick-close on each link).
  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  return (
    <div className="flex h-screen overflow-hidden" style={{ backgroundColor: '#F8FAFC' }}>
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        {/* Mobile/tablet top bar — the sidebar itself is always visible as a
            static column on lg+ screens, so this bar (and its hamburger
            toggle) only needs to exist below that breakpoint. */}
        <header className="lg:hidden flex items-center gap-3 px-4 py-3 bg-white border-b border-gray-200 shrink-0">
          <button
            type="button"
            onClick={() => setSidebarOpen(true)}
            aria-label="Open menu"
            className="p-2 -ml-2 rounded-lg text-gray-700 hover:bg-gray-100"
            data-testid="mobile-sidebar-toggle"
          >
            <Menu size={22} />
          </button>
          <h1
            className="text-lg font-bold"
            style={{ fontFamily: 'Manrope, sans-serif', color: '#C2410C' }}
          >
            FoodKAdmin
          </h1>
        </header>

        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>

      {/* Global new-order alerts — visible on every protected page */}
      {can('orders', 'view') && <NewOrdersPopup />}
    </div>
  );
};

export default Layout;
